import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_3 = { class: "px-6 md:px-8 pt-6 pb-20" }
const _hoisted_4 = { class: "max-w-[1040px]" }
const _hoisted_5 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_6 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_7 = { class: "flex flex-wrap gap-x-6 gap-y-2" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = {
  key: 0,
  class: "grid gap-5 sm:grid-cols-2"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["pattern"]
const _hoisted_14 = { class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5" }
const _hoisted_15 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_16 = ["pattern"]
const _hoisted_17 = { class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5" }
const _hoisted_18 = {
  key: 0,
  class: "grid gap-5 border-t border-gray-100 pt-5 sm:grid-cols-2"
}
const _hoisted_19 = ["pattern"]
const _hoisted_20 = { class: "flex items-center justify-between gap-6" }
const _hoisted_21 = { class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5" }
const _hoisted_22 = {
  key: 0,
  class: "grid gap-5 border-t border-gray-100 pt-5 sm:grid-cols-2"
}
const _hoisted_23 = ["pattern"]
const _hoisted_24 = { class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5" }
const _hoisted_25 = {
  key: 1,
  class: "space-y-2 border-t border-gray-100 pt-5"
}
const _hoisted_26 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_27 = ["id", "value", "checked", "onChange"]
const _hoisted_28 = ["for"]
const _hoisted_29 = { class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5" }
const _hoisted_30 = {
  key: 2,
  class: "border-t border-gray-100 pt-5"
}
const _hoisted_31 = { class: "flex flex-wrap items-center gap-2 p-2 border border-gray-300 rounded-md" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "flex items-center justify-between gap-6" }
const _hoisted_34 = {
  key: 0,
  class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5"
}
const _hoisted_35 = { class: "flex items-center justify-between gap-6" }
const _hoisted_36 = { class: "flex items-center justify-between gap-6 border-t border-gray-100 pt-5" }
const _hoisted_37 = {
  key: 0,
  class: "btn-primary",
  type: "submit"
}

import { computed, ref } from 'vue'
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import InputField from '@/components/neue/InputField'
import NeueToggle from '@/components/neue/NeueToggle'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import ReportChart from '@/components/reports/ReportChart.vue'
import { useBackLink } from '@/composables/useBackLink'
import { useRouteTabs } from '@/composables/useRouteTabs'
import { DECIMAL_NUMBER_PATTERN, discountRateToPercent } from '@/helpers/discountFormat'
import { parseDiscountCodeUsageReport } from '@/services/reportParser.service'
import api from '@/store/api'


export default {
  __name: 'DiscountCodeDetail',
  setup(__props) {

const TABS = [
  { id: 'overview', name: 'Overview' },
  { id: 'settings', name: 'Settings' }
]

const route = useRoute()
const router = useRouter()
const backLink = useBackLink('/store/discount-codes/manage')
const store = useStore()

const { activeTab, sections } = useRouteTabs(
  TABS,
  computed(() => '/store/discount-codes/' + route.params.id)
)

// Overview tab state
const reportLoading = ref(false)
const chartData = ref({ labels: [], datasets: [] })
const reportTableData = ref(null)
const hasUnsavedChanges = ref(false)
const leaveModal = ref(false)
const codeError = ref('')
const regex = {
  number: '^[0-9]*$',
  decimalNumber: DECIMAL_NUMBER_PATTERN,
  letterNumberDashUnderscore: '[^A-Za-z0-9_-]*$',
  ddMmYyyyDate:
    '^(((0[1-9]|[12][0-9]|3[01])[- /.](0[13578]|1[02])|(0[1-9]|[12][0-9]|30)[- /.](0[469]|11)|(0[1-9]|1\\d|2[0-8])[- /.]02)[- /.]\\d{4}|29[- /.]02[- /.](\\d{2}(0[48]|[2468][048]|[13579][26])|([02468][048]|[1359][26])00))$'
}

onBeforeRouteLeave((to, from, next) => {
  if (hasUnsavedChanges.value) {
    leaveModal.value = true
    next(false)
  } else next()
})

const local = ref({
  name: '',
  code: '',
  type: '',
  percentage: '',
  amount: '',
  maxAmount: '',
  maxUseTimesPerUser: '',
  canBeCombined: false,
  canBeCombinedAlways: false,
  canExpire: false,
  expirationDate: '',
  firstTimeCustomerOnly: false,
  autoApplyOnceUsed: false,
  automaticallyApply: false,
  appliesToMaxDiscountStoreSetting: false,
  hasMinimumCartValue: false,
  minimumCartValue: '',
  hasMembershipTierRestriction: false,
  membershipTierIds: [],
  hasTagRestriction: false,
  restrictedTagsList: []
})

const membershipTiers = ref([])
api.call('GET', 'membership_tiers').then(response => {
  membershipTiers.value = (response.data.data || []).map(t => ({
    id: parseInt(t.id, 10),
    name: t.attributes.tier_name
  }))
})

const tagInputDraft = ref('')

const addTagFromDraft = () => {
  const raw = tagInputDraft.value.trim().toLowerCase()
  if (!raw) return
  if (!local.value.restrictedTagsList.includes(raw)) {
    local.value.restrictedTagsList = [...local.value.restrictedTagsList, raw]
    hasUnsavedChanges.value = true
  }
  tagInputDraft.value = ''
}

const removeTag = tag => {
  local.value.restrictedTagsList = local.value.restrictedTagsList.filter(t => t !== tag)
  hasUnsavedChanges.value = true
}

const handleTagKeydown = event => {
  if (event.key === 'Enter' || event.key === ',') {
    event.preventDefault()
    addTagFromDraft()
  } else if (event.key === 'Backspace' && !tagInputDraft.value && local.value.restrictedTagsList.length) {
    removeTag(local.value.restrictedTagsList[local.value.restrictedTagsList.length - 1])
  }
}

const loadCode = id =>
  api.call('GET', `discount_codes/${id}`).then(response => {
    const attrs = response.data.data.attributes
    local.value = {
      name: attrs.discount_code_name,
      code: attrs.code,
      type: attrs.type,
      percentage: discountRateToPercent(attrs.discount_rate),
      amount: (attrs.discount_amount.cents / 100).toFixed(2),
      maxAmount: attrs.maximum_discount_amount.cents / 100,
      maxUseTimesPerUser: attrs.max_use_times_per_user,
      canBeCombined: attrs.can_be_combined,
      canBeCombinedAlways: attrs.can_be_combined_always,
      canExpire: attrs.code_can_expire,
      expirationDate: attrs.expiration_date,
      firstTimeCustomerOnly: attrs.first_time_customer_only,
      autoApplyOnceUsed: attrs.auto_apply_once_used,
      automaticallyApply: attrs.automatically_apply,
      appliesToMaxDiscountStoreSetting: attrs.applies_to_max_discount_store_setting,
      hasMinimumCartValue: attrs.minimum_cart_value != null,
      minimumCartValue: attrs.minimum_cart_value != null ? (attrs.minimum_cart_value / 100).toFixed(2) : '',
      hasMembershipTierRestriction: (attrs.membership_tier_ids || []).length > 0,
      membershipTierIds: attrs.membership_tier_ids || [],
      hasTagRestriction: !!attrs.restricted_tags,
      restrictedTagsList: attrs.restricted_tags ? attrs.restricted_tags.split(',') : []
    }
  })

const fetchReportData = async (id = route.params.id) => {
  reportLoading.value = true
  try {
    const end = new Date()
    const start = new Date(end)
    start.setDate(end.getDate() - 90)
    const toYMD = d => d.toISOString().slice(0, 10)

    const params = new URLSearchParams({
      beginning_date: toYMD(start),
      ending_date: toYMD(end),
      group_by: 'day'
    })
    params.append('discount_code_ids[]', id)

    const res = await api.call('GET', `data_downloads/reports/discount_code_usage_report?${params.toString()}`)
    const parsed = parseDiscountCodeUsageReport(res)
    chartData.value = parsed.chartData
    reportTableData.value = parsed.tableData
  } catch (error) {
    console.error('Error fetching discount code report data:', error)
  } finally {
    reportLoading.value = false
  }
}

const validateCode = () => {
  const regexPattern = new RegExp(regex.letterNumberDashUnderscore, 'g')
  local.value.code = local.value.code.toUpperCase().replace(/\s/g, '-').replace(regexPattern, '')
  codeError.value = ''
}

const handleKeydown = event => {
  if (event.keyCode === 13 && event.target.localName !== 'textarea') event.preventDefault()
}

const handleDiscardChanges = () => {
  location.reload()
}

const handleConfirmCancelChanges = () => {
  hasUnsavedChanges.value = false
  router.push('/store/discount-codes')
}

const del = () => {
  api.call('DELETE', `discount_codes/${route.params.id}`).then(() => router.push('/store/discount-codes/manage'))
}

const handleSubmit = async () => {
  codeError.value = ''
  try {
    await api.call('PUT', `discount_codes/${route.params.id}`, {
      discount_code: {
        discount_code_name: local.value.name,
        code: local.value.code,
        type: local.value.type,
        discount_rate: local.value.percentage * 0.01,
        maximum_discount_amount_cents: local.value.maxAmount * 100,
        discount_amount_cents: local.value.amount * 100,
        max_use_times_per_user: local.value.maxUseTimesPerUser,
        can_be_combined: local.value.canBeCombined,
        can_be_combined_always: local.value.canBeCombinedAlways,
        code_can_expire: local.value.canExpire,
        expiration_date: local.value.expirationDate,
        first_time_customer_only: local.value.firstTimeCustomerOnly,
        auto_apply_once_used: local.value.autoApplyOnceUsed,
        automatically_apply: local.value.automaticallyApply,
        applies_to_max_discount_store_setting: local.value.appliesToMaxDiscountStoreSetting,
        minimum_cart_value: local.value.hasMinimumCartValue
          ? Math.round(parseFloat(local.value.minimumCartValue) * 100)
          : null,
        membership_tier_ids: local.value.hasMembershipTierRestriction ? local.value.membershipTierIds : [],
        restricted_tags:
          local.value.hasTagRestriction && local.value.restrictedTagsList.length > 0
            ? local.value.restrictedTagsList.join(',')
            : null
      }
    })
    hasUnsavedChanges.value = false
  } catch (error) {
    if (error.response?.status === 422) {
      const message = error.response.data?.errors?.[0]
      codeError.value = message || 'This code is already taken.'
      return
    }
    codeError.value = 'Unable to save right now. Please try again.'
  }
}

const load = id => {
  loadCode(id)
  fetchReportData(id)
}
load(route.params.id)
onBeforeRouteUpdate((to, from) => {
  if (to.params.id !== from.params.id) load(to.params.id)
})

return (_ctx, _cache) => {
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_router_link = _resolveComponent("router-link")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: local.value.name,
        parent: _unref(backLink),
        "save-status": _unref(activeTab) === 'settings',
        sections: _unref(sections)
      }, null, 8, ["text", "parent", "save-status", "sections"]),
      (_unref(activeTab) === 'settings')
        ? (_openBlock(), _createBlock(_component_SaveBar, {
            key: 0,
            "has-unsaved-changes": hasUnsavedChanges.value,
            onOnDiscard: _cache[0] || (_cache[0] = $event => (handleDiscardChanges())),
            onOnSave: _cache[1] || (_cache[1] = $event => (handleSubmit()))
          }, null, 8, ["has-unsaved-changes"]))
        : _createCommentVNode("", true)
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_component_NeueLoading, { loading: reportLoading.value }, {
            default: _withCtx(() => [
              _createVNode(ReportChart, {
                "report-id": `discount-code-detail-${_unref(route).params.id}`,
                title: local.value.code || local.value.name,
                description: "Last 90 days",
                "empty-state-title": "No usage in the last 90 days",
                "empty-state-description": "Share this discount code to start seeing usage data here.",
                "label-column-title": "Name",
                "chart-data": chartData.value,
                "has-supporting-table": true,
                "table-data": reportTableData.value,
                "chart-type": "line",
                "date-filter": false,
                "dropdown-filter": false,
                loading: reportLoading.value,
                "currency-format": true,
                "table-hover-enabled": false,
                "view-report-link": '/discount-code-usage?code_id=' + _unref(route).params.id
              }, null, 8, ["report-id", "title", "chart-data", "table-data", "loading", "view-report-link"])
            ]),
            _: 1
          }, 8, ["loading"])
        ], 512), [
          [_vShow, _unref(activeTab) === 'overview']
        ]),
        _withDirectives(_createElementVNode("form", {
          class: "flex flex-1 flex-col justify-between",
          onSubmit: _cache[34] || (_cache[34] = _withModifiers($event => (handleSubmit()), ["prevent"])),
          onKeydown: [
            _cache[35] || (_cache[35] = _withKeys(_withModifiers($event => (handleSubmit()), ["meta","exact"]), ["enter"])),
            _cache[36] || (_cache[36] = _withKeys($event => (handleKeydown($event)), ["enter"]))
          ],
          onInput: _cache[37] || (_cache[37] = $event => (hasUnsavedChanges.value = true))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(SettingsSection, {
                title: "Details",
                description: "The name your team knows this code by and the code customers enter at checkout."
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", {
                        for: "name",
                        class: "block text-sm font-medium text-gray-700 mb-1"
                      }, "Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "name",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((local.value.name) = $event)),
                        type: "text",
                        name: "name",
                        class: "block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      }, null, 512), [
                        [_vModelText, local.value.name]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[42] || (_cache[42] = _createElementVNode("label", {
                        for: "code",
                        class: "block text-sm font-medium text-gray-700 mb-1"
                      }, "Code", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "code",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((local.value.code) = $event)),
                        type: "text",
                        name: "code",
                        class: "block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 invalid:border-red-100 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm font-mono",
                        onInput: validateCode
                      }, null, 544), [
                        [_vModelText, local.value.code]
                      ]),
                      (codeError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(codeError.value), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(SettingsSection, {
                title: "Discount",
                description: "What customers get off their order with this code."
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _cache[46] || (_cache[46] = _createElementVNode("label", {
                      for: "type",
                      class: "block text-sm font-medium text-gray-700 mb-2"
                    }, "Type", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          id: "percent_off",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((local.value.type) = $event)),
                          name: "type",
                          type: "radio",
                          value: "PercentOffDiscountCode",
                          class: "w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                        }, null, 512), [
                          [_vModelRadio, local.value.type]
                        ]),
                        _cache[43] || (_cache[43] = _createElementVNode("label", {
                          for: "percent_off",
                          class: "ml-2 block text-sm font-medium text-gray-700"
                        }, "Percent off", -1))
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          id: "amount_off",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((local.value.type) = $event)),
                          name: "type",
                          value: "AmountOffDiscountCode",
                          type: "radio",
                          class: "w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                        }, null, 512), [
                          [_vModelRadio, local.value.type]
                        ]),
                        _cache[44] || (_cache[44] = _createElementVNode("label", {
                          for: "amount_off",
                          class: "ml-2 block text-sm font-medium text-gray-700"
                        }, "Amount off", -1))
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          id: "free_shipping",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((local.value.type) = $event)),
                          name: "type",
                          type: "radio",
                          value: "FreeShippingDiscountCode",
                          class: "w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                        }, null, 512), [
                          [_vModelRadio, local.value.type]
                        ]),
                        _cache[45] || (_cache[45] = _createElementVNode("label", {
                          for: "free_shipping",
                          class: "ml-2 block text-sm font-medium text-gray-700"
                        }, " Free shipping ", -1))
                      ])
                    ])
                  ]),
                  (['PercentOffDiscountCode', 'AmountOffDiscountCode'].includes(local.value.type))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (local.value.type === 'PercentOffDiscountCode')
                          ? (_openBlock(), _createBlock(_unref(InputField), {
                              key: 0,
                              modelValue: local.value.percentage,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((local.value.percentage) = $event)),
                              name: "Discount Amount",
                              prefix: "%",
                              restrict: "float",
                              pattern: regex.decimalNumber,
                              title: "Numbers only"
                            }, null, 8, ["modelValue", "pattern"]))
                          : _createCommentVNode("", true),
                        (local.value.type === 'PercentOffDiscountCode')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _cache[47] || (_cache[47] = _createElementVNode("label", {
                                for: "max_discount_amount",
                                class: "block text-sm font-medium text-gray-700 mb-1"
                              }, " Maximum discount amount ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "max_discount_amount",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((local.value.maxAmount) = $event)),
                                pattern: regex.decimalNumber,
                                type: "text",
                                inputmode: "numeric",
                                title: "Numbers only",
                                name: "max_discount_amount",
                                class: "block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 invalid:border-red-100 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                              }, null, 8, _hoisted_13), [
                                [_vModelText, local.value.maxAmount]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (local.value.type === 'AmountOffDiscountCode')
                          ? (_openBlock(), _createBlock(_unref(InputField), {
                              key: 2,
                              modelValue: local.value.amount,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((local.value.amount) = $event)),
                              name: "Discount Amount",
                              prefix: "$",
                              restrict: "monetary",
                              pattern: regex.decimalNumber,
                              title: "Numbers only"
                            }, null, 8, ["modelValue", "pattern"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Applies to max discount on store"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Cap this code's discount at your store's maximum discount setting. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: local.value.appliesToMaxDiscountStoreSetting,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((local.value.appliesToMaxDiscountStoreSetting) = $event)),
                      onChange: _cache[11] || (_cache[11] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(SettingsSection, {
                title: "Usage limits",
                description: "How many times each customer can use this code, and when it stops working."
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _cache[49] || (_cache[49] = _createElementVNode("label", {
                        for: "max_uses",
                        class: "block text-sm font-medium text-gray-700 mb-1"
                      }, " Max use times per user ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "max_uses",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((local.value.maxUseTimesPerUser) = $event)),
                        type: "text",
                        inputmode: "numeric",
                        pattern: regex.number,
                        title: "Numbers only",
                        name: "max_uses",
                        class: "block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 invalid:border-red-100 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm font-mono"
                      }, null, 8, _hoisted_16), [
                        [_vModelText, local.value.maxUseTimesPerUser]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Can expire"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Give this code an expiry date, after which it can no longer be used. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: local.value.canExpire,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((local.value.canExpire) = $event)),
                      onChange: _cache[14] || (_cache[14] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"])
                  ]),
                  (local.value.canExpire)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", null, [
                          _cache[51] || (_cache[51] = _createElementVNode("label", {
                            for: "expiration_date",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, " Expiration date ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "expiration_date",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((local.value.expirationDate) = $event)),
                            pattern: regex.ddMmYyyyDate,
                            type: "date",
                            name: "expiration_date",
                            class: "block w-full border-gray-300 focus:border-blue-500 rounded-md shadow-sm invalid:border-red-100 focus:ring-blue-500 sm:text-sm"
                          }, null, 8, _hoisted_19), [
                            [_vModelText, local.value.expirationDate]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(SettingsSection, {
                title: "Restrictions",
                description: "Limit which customers and carts can use this code."
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "First time customer only"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Only customers who have never ordered before can use this code. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: local.value.firstTimeCustomerOnly,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((local.value.firstTimeCustomerOnly) = $event)),
                      onChange: _cache[17] || (_cache[17] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Minimum cart value"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Require the cart to reach a minimum value before this code can be used. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: local.value.hasMinimumCartValue,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((local.value.hasMinimumCartValue) = $event)),
                      onChange: _cache[19] || (_cache[19] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"])
                  ]),
                  (local.value.hasMinimumCartValue)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", null, [
                          _cache[54] || (_cache[54] = _createElementVNode("label", {
                            for: "minimum_cart_value",
                            class: "block text-sm font-medium text-gray-700 mb-1"
                          }, " Minimum amount ($) ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "minimum_cart_value",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((local.value.minimumCartValue) = $event)),
                            type: "text",
                            inputmode: "numeric",
                            pattern: regex.decimalNumber,
                            title: "Numbers only",
                            name: "minimum_cart_value",
                            class: "block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 invalid:border-red-100 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                          }, null, 8, _hoisted_23), [
                            [_vModelText, local.value.minimumCartValue]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Membership tier"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Limit this code to customers on specific membership tiers. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: local.value.hasMembershipTierRestriction,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((local.value.hasMembershipTierRestriction) = $event)),
                      onChange: _cache[22] || (_cache[22] = 
                      on => {
                        if (!on) local.value.membershipTierIds = []
                        hasUnsavedChanges.value = true
                      }
                    )
                    }, null, 8, ["modelValue"])
                  ]),
                  (local.value.hasMembershipTierRestriction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (!membershipTiers.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_26, "No membership tiers configured."))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(membershipTiers.value, (tier) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: tier.id,
                            class: "flex items-center"
                          }, [
                            _createElementVNode("input", {
                              id: `membership_tier_${tier.id}`,
                              type: "checkbox",
                              value: tier.id,
                              checked: local.value.membershipTierIds.includes(tier.id),
                              class: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500",
                              onChange: 
                        event => {
                          if (event.target.checked) {
                            local.value.membershipTierIds = [...local.value.membershipTierIds, tier.id]
                          } else {
                            local.value.membershipTierIds = local.value.membershipTierIds.filter(id => id !== tier.id)
                          }
                          hasUnsavedChanges.value = true
                        }
                      
                            }, null, 40, _hoisted_27),
                            _createElementVNode("label", {
                              for: `membership_tier_${tier.id}`,
                              class: "ml-2 block text-sm text-gray-700"
                            }, _toDisplayString(tier.name), 9, _hoisted_28)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_29, [
                    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Customer tag"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Limit this code to customers with specific tags. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: local.value.hasTagRestriction,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((local.value.hasTagRestriction) = $event)),
                      onChange: _cache[24] || (_cache[24] = 
                      on => {
                        if (!on) local.value.restrictedTagsList = []
                        hasUnsavedChanges.value = true
                      }
                    )
                    }, null, 8, ["modelValue"])
                  ]),
                  (local.value.hasTagRestriction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(local.value.restrictedTagsList, (tag) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: tag,
                              class: "inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded text-sm"
                            }, [
                              _createTextVNode(_toDisplayString(tag) + " ", 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-blue-600 hover:text-blue-800 cursor-pointer",
                                onClick: $event => (removeTag(tag))
                              }, " × ", 8, _hoisted_32)
                            ]))
                          }), 128)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => ((tagInputDraft).value = $event)),
                            type: "text",
                            placeholder: "Type a tag and press Enter",
                            class: "flex-1 min-w-[120px] border-0 p-1 text-sm focus:outline-none focus:ring-0",
                            onKeydown: handleTagKeydown
                          }, null, 544), [
                            [_vModelText, tagInputDraft.value]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(SettingsSection, {
                title: "Combining codes",
                description: "Whether customers can use this code together with other discount codes on the same order."
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Can be combined"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Allow this code to be used together with other discount codes on the same order. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: local.value.canBeCombined,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => ((local.value.canBeCombined) = $event)),
                      onChange: _cache[27] || (_cache[27] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"])
                  ]),
                  (local.value.canBeCombined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _cache[58] || (_cache[58] = _createElementVNode("div", { class: "min-w-0" }, [
                          _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Can be combined always"),
                          _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Always let this code stack with others, even codes marked as not combinable. ")
                        ], -1)),
                        _createVNode(_unref(NeueToggle), {
                          modelValue: local.value.canBeCombinedAlways,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => ((local.value.canBeCombinedAlways) = $event)),
                          onChange: _cache[29] || (_cache[29] = $event => (hasUnsavedChanges.value = true))
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(SettingsSection, {
                title: "Automatic apply",
                description: "Apply this code for customers so they do not have to enter it."
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, [
                    _cache[59] || (_cache[59] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Automatically apply"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Apply this code automatically at checkout for any customer whose order meets all its conditions, without them entering it. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: local.value.automaticallyApply,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => ((local.value.automaticallyApply) = $event)),
                      onChange: _cache[31] || (_cache[31] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _cache[60] || (_cache[60] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Keep applying to customer once they use"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " After a customer uses this code once, reapply it automatically to their future orders. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: local.value.autoApplyOnceUsed,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => ((local.value.autoApplyOnceUsed) = $event)),
                      onChange: _cache[33] || (_cache[33] = $event => (hasUnsavedChanges.value = true))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_PageFooter, null, {
            left: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn-alert",
                type: "button",
                onClick: _withModifiers(del, ["prevent"])
              }, "Delete")
            ]),
            right: _withCtx(() => [
              (hasUnsavedChanges.value)
                ? (_openBlock(), _createElementBlock("button", _hoisted_37, "Save"))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    class: "btn-primary",
                    type: "button",
                    to: "/store/discount-codes"
                  }, {
                    default: _withCtx(() => [...(_cache[61] || (_cache[61] = [
                      _createTextVNode("Done", -1)
                    ]))]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ], 544), [
          [_vShow, _unref(activeTab) === 'settings']
        ]),
        _withDirectives(_createVNode(_component_TheModal, {
          "is-open": leaveModal.value,
          "modal-title": "Abandon changes",
          "modal-description": "Are you sure you'd like to leave without saving your changes?",
          onCloseModal: _cache[40] || (_cache[40] = $event => (leaveModal.value = false))
        }, {
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn-alert justify-center mr-3",
              onClick: _cache[38] || (_cache[38] = $event => (handleConfirmCancelChanges()))
            }, "Leave"),
            _createElementVNode("button", {
              class: "btn-ghost justify-center",
              type: "button",
              onClick: _cache[39] || (_cache[39] = $event => (leaveModal.value = false))
            }, "Stay")
          ]),
          _: 1
        }, 8, ["is-open"]), [
          [_vShow, leaveModal.value]
        ])
      ])
    ]),
    _: 1
  }))
}
}

}